// src/components/invoices/InvoiceCardSkeleton.tsx
import { Box, Card, Flex, HStack, Skeleton, VStack } from '@chakra-ui/react'

export default function InvoiceCardSkeleton() {
  return (
    <Card.Root>
      <Card.Body>
        <Flex justify="space-between" gap="4">
          <Box flex="1">
            <Skeleton height="20px" width="70%" />
            <Skeleton height="14px" width="55%" mt="2" />

            <Skeleton height="20px" width="40%" mt="4" />

            <HStack mt="3" gap="2">
              <Skeleton height="10px" width="10px" />
              <Skeleton height="14px" width="40%" />
            </HStack>
          </Box>

          <VStack align="flex-end" gap="2">
            <Skeleton height="14px" width="90px" />
            <Skeleton height="14px" width="110px" />
          </VStack>
        </Flex>
      </Card.Body>
    </Card.Root>
  )
}
